export default __webpack_public_path__ + "static/media/pepper-grinder.0b2fdb33.mp3";